"use strict";
exports.__esModule = true;
var chartDefaultOptions_1 = require("../components/chartDefaultOptions");
var floor_1 = require("./floor");
var createChartOptions = function (chartData, datasetsValue, barType, frequency, customStyles) {
    var _a, _b;
    var selectedChart = Array.isArray(chartData)
        ? (_a = chartData.find(function (item) { var _a, _b; return ((_b = (_a = item.header) === null || _a === void 0 ? void 0 : _a.scope) === null || _b === void 0 ? void 0 : _b.frequency) === frequency; })) !== null && _a !== void 0 ? _a : chartData[0]
        : chartData;
    var currentDatasets = datasetsValue !== 'all'
        ? selectedChart === null || selectedChart === void 0 ? void 0 : selectedChart.structure.datasets.filter(function (dataset) { return dataset.id === datasetsValue; })
        : selectedChart === null || selectedChart === void 0 ? void 0 : selectedChart.structure.datasets;
    var hasRightYAxis = currentDatasets
        ? currentDatasets.map(function (item) { return item.position; }).find(function (item) { return item && item.toUpperCase() == 'RIGHT'; }) !== undefined
        : Array.isArray(chartData)
            ? chartData[0].structure.datasets
                .map(function (item) { return item.position; })
                .find(function (item) { return item && item.toUpperCase() == 'RIGHT'; }) !== undefined
            : chartData.structure.datasets
                .map(function (item) { return item.position; })
                .find(function (item) { return item && item.toUpperCase() == 'RIGHT'; }) !== undefined;
    var hasPercentageOfLeft = currentDatasets
        ? currentDatasets
            .map(function (item) {
            return { position: item.position, percentage: item.percentage };
        })
            .find(function (item) { return item.position && item.position.toUpperCase() == 'LEFT' && item.percentage; }) !== undefined
        : Array.isArray(chartData)
            ? chartData[0].structure.datasets
                .filter(function (dataset) { return dataset.label == datasetsValue; })
                .map(function (item) {
                return { position: item.position, percentage: item.percentage };
            })
                .find(function (item) { return item.position && item.position.toUpperCase() == 'LEFT' && item.percentage; }) !== undefined
            : chartData.structure.datasets
                .filter(function (dataset) { return dataset.label == datasetsValue; })
                .map(function (item) {
                return { position: item.position, percentage: item.percentage };
            })
                .find(function (item) { return item.position && item.position.toUpperCase() == 'LEFT' && item.percentage; }) !== undefined;
    var hasPercentageOfRight = currentDatasets
        ? currentDatasets
            .map(function (item) {
            return { position: item.position, percentage: item.percentage };
        })
            .find(function (item) { return item.position && item.position.toUpperCase() == 'RIGHT' && item.percentage; }) !== undefined
        : Array.isArray(chartData)
            ? chartData[0].structure.datasets
                .filter(function (dataset) { return dataset.label == datasetsValue; })
                .map(function (item) {
                return { position: item.position, percentage: item.percentage };
            })
                .find(function (item) { return item.position && item.position.toUpperCase() == 'RIGHT' && item.percentage; }) !== undefined
            : chartData.structure.datasets
                .filter(function (dataset) { return dataset.label == datasetsValue; })
                .map(function (item) {
                return { position: item.position, percentage: item.percentage };
            })
                .find(function (item) { return item.position && item.position.toUpperCase() == 'RIGHT' && item.percentage; }) !== undefined;
    var hasBarChartOfRight = currentDatasets
        ? currentDatasets.some(function (item) { return item.type === 'BAR' && item.position === 'RIGHT'; })
        : false;
    // const hasBarChartOfRight = currentDatasets
    //   ? currentDatasets.find((item) => item.position && item.position.toUpperCase() == 'RIGHT' && item.type == 'BAR') !==
    //     undefined
    //   : Array.isArray(chartData)
    //   ? chartData[0].structure.datasets
    //       .filter((dataset) => dataset.label == datasetsValue)
    //       .find((item) => item.position && item.position.toUpperCase() == 'RIGHT' && item.type == 'BAR') !== undefined
    //   : chartData.structure.datasets
    //       .filter((dataset) => dataset.label == datasetsValue)
    //       .find((item) => item.position && item.position.toUpperCase() == 'RIGHT' && item.type == 'BAR') !== undefined;
    var hasBarChartOfLeft = currentDatasets
        ? currentDatasets.some(function (item) { return item.type === 'BAR' && item.position === 'LEFT'; })
        : false;
    // const hasBarChartOfLeft = currentDatasets
    //   ? currentDatasets.find((item) => item.position && item.position.toUpperCase() == 'LEFT' && item.type == 'BAR') !==
    //     undefined
    //   : Array.isArray(chartData)
    //   ? chartData[0].structure.datasets
    //       .filter((dataset) => dataset.label == datasetsValue)
    //       .find((item) => item.position && item.position.toUpperCase() == 'LEFT' && item.type == 'BAR') !== undefined
    //   : chartData.structure.datasets
    //       .filter((dataset) => dataset.label == datasetsValue)
    //       .find((item) => item.position && item.position.toUpperCase() == 'LEFT' && item.type == 'BAR') !== undefined;
    var datasets = currentDatasets === null || currentDatasets === void 0 ? void 0 : currentDatasets.slice().sort(function (a, b) {
        if (a.type === 'LINE' && b.type !== 'LINE')
            return -1;
        return 0;
    });
    var percentDatasetNumbers = datasets
        ? datasets.map(function (item, index) {
            return item.percentage ? index : -1;
        })
        : Array.isArray(chartData)
            ? chartData[0].structure.datasets
                .filter(function (dataset) { return dataset.label == datasetsValue; })
                .map(function (item, index) {
                return item.percentage ? index : -1;
            })
            : chartData.structure.datasets
                .filter(function (dataset) { return dataset.label == datasetsValue; })
                .map(function (item, index) {
                return item.percentage ? index : -1;
            });
    return Object.assign({}, chartDefaultOptions_1["default"], {
        elements: {
            line: {
                tension: (_b = customStyles === null || customStyles === void 0 ? void 0 : customStyles.lineTension) !== null && _b !== void 0 ? _b : 0.4
            },
            point: {
                radius: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.hidePoints) ? 0 : 2
            }
        },
        tooltips: {
            mode: 'index',
            position: 'average',
            caretSize: 0,
            caretPadding: 16,
            callbacks: {
                label: function (tooltipItem) {
                    return datasets
                        ? !isNaN(tooltipItem.yLabel)
                            ? percentDatasetNumbers.find(function (item) { return item == tooltipItem.datasetIndex; }) !== undefined
                                ? datasets[tooltipItem.datasetIndex].label + ' : ' + (0, floor_1["default"])(tooltipItem.yLabel * 100, 2).toFixed(2) + '%'
                                : datasets[tooltipItem.datasetIndex].label +
                                    ' : ' +
                                    tooltipItem.yLabel.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
                            : datasets[tooltipItem.datasetIndex].label + ' : '
                        : 'No data';
                }
            }
        },
        hover: {
            mode: 'index'
        },
        legend: {
            display: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.hideLegends) ? false : true,
            position: 'bottom',
            labels: {
                fontFamily: '"Montserrat", "Helvetica Neue", Helvetica, Arial, sans-serif',
                boxWidth: 20,
                padding: 8,
                usePointStyle: true
            }
        },
        scales: {
            xAxes: [
                {
                    stacked: barType === 'STACKED_BAR' || barType === 'PERCENTAGE_BAR',
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        maxTicksLimit: 16
                    }
                },
            ],
            yAxes: hasRightYAxis
                ? [
                    {
                        id: 'left-y-axis',
                        type: 'linear',
                        stacked: hasBarChartOfLeft && (barType === 'STACKED_BAR' || barType === 'PERCENTAGE_BAR'),
                        position: 'left',
                        ticks: {
                            beginAtZero: !hasPercentageOfLeft,
                            callback: function (value) {
                                return hasPercentageOfLeft
                                    ? (0, floor_1["default"])(value * 100, 2).toFixed(2) + '%'
                                    : value.toLocaleString(navigator.language, { minimumFractionDigits: 0 });
                            }
                        }
                    },
                    {
                        id: 'right-y-axis',
                        type: 'linear',
                        stacked: hasBarChartOfRight && (barType === 'STACKED_BAR' || barType === 'PERCENTAGE_BAR'),
                        position: 'right',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        ticks: {
                            beginAtZero: !hasPercentageOfRight,
                            callback: function (value) {
                                return hasPercentageOfRight
                                    ? (0, floor_1["default"])(value * 100, 2).toFixed(2) + '%'
                                    : value.toLocaleString(navigator.language, { minimumFractionDigits: 0 });
                            }
                        }
                    },
                ]
                : [
                    {
                        id: 'left-y-axis',
                        type: 'linear',
                        stacked: hasBarChartOfLeft && (barType === 'STACKED_BAR' || barType === 'PERCENTAGE_BAR'),
                        position: 'left',
                        ticks: {
                            beginAtZero: true,
                            callback: function (value) {
                                return hasPercentageOfLeft
                                    ? (0, floor_1["default"])(value * 100, 2).toFixed(2) + '%'
                                    : value.toLocaleString(navigator.language, { minimumFractionDigits: 0 });
                            }
                        }
                    },
                ]
        }
    });
};
exports["default"] = createChartOptions;
